import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Drawer, IconButton } from '@mui/material';

import { LeaderboardTrader, TimeFilter } from '@/types';
import { BiggestWins } from './BiggestWins';

interface LeaderboardMobileWinsProps {
  isOpen: boolean;
  onClose: () => void;
  biggestWinsData: LeaderboardTrader[];
  selectedTimeFilter: TimeFilter;
  isLoading: boolean;
}

export const LeaderboardMobileWins = ({
  isOpen,
  onClose,
  biggestWinsData,
  selectedTimeFilter,
  isLoading,
}: LeaderboardMobileWinsProps) => {
  return (
    <Drawer
      anchor="bottom"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          p: 0,
          maxHeight: '85vh',
        },
      }}
    >
      <Box sx={{ overflowY: 'auto', flex: 1 }}>
        <BiggestWins
          biggestWinsData={biggestWinsData}
          selectedTimeFilter={selectedTimeFilter}
          isLoading={isLoading}
          onClose={onClose}
        />
      </Box>
    </Drawer>
  );
};
